import { useState } from "react";
import StackedAreaChart from "./ChartStackedArea";
import ChartCard from "./ChartCard";

const MethodsOverTime = ({ uid, timelineData, metric }) => {
  const [brushRange, setBrushRange] = useState(null);
  const dataLoader = (user) => {
    return user.snapshot.methodsOverTime(user);
  };

  const isEmptyChecker = (data) => {
    return (
      !data || data.every((obj) => Object.keys(obj).length === 1 && "x" in obj)
    );
  };

  return (
    <ChartCard
      uid={uid}
      title="Methods over Time"
      dataLoader={dataLoader}
      isEmptyChecker={isEmptyChecker}
      height={400}
    >
      {(data) => (
        <StackedAreaChart
          data={data}
          brushRange={brushRange}
          setBrushRange={setBrushRange}
          timelineData={timelineData}
          metric={metric}
        />
      )}
    </ChartCard>
  );
};

export default MethodsOverTime;
